import { IActivatedMod } from './gamecloud/submodules/mod/interface';
import { IMapData, PageType } from './gamecloud/interface';
import { initCheckbox, Checkbox } from './components/checkbox/checkbox';
import { Server } from './units/server/server';

import { initRegionNotification } from './regionNotification/regionNotification';
import { initAdminbar } from './adminbar/adminbar';
import { GPTooltip } from './tooltip/tooltip';
import { initGameserver } from './gamecloud/submodules/gameserver/gameserver';
import { initModal, Modal } from './modal/modal';
import { initGameserverStatus } from './gamecloud/submodules/gameserver/submodules/gameserverStatus';
import { initMap } from './gamecloud/submodules/gameserver/submodules/map/map';
import { initConfiguration } from './gamecloud/submodules/configuration/configuration';
import { initGameserverHeader } from './gamecloud/submodules/header/header';
import { initMod } from './gamecloud/submodules/mod/mod';
import { initLogs } from './gamecloud/submodules/logs/logs';
import { initPermissions } from './gamecloud/submodules/permissions/permissions';
import { initRestarts } from './gamecloud/submodules/restarts/restart';
import { initConsole } from './gamecloud/submodules/console/consoleFactory';
import { initGame } from './gamecloud/submodules/game/game';
import { initGameserverState } from './gamecloud/submodules/gameserver/submodules/gameserverState';
import { initGamecloudheader } from './gamecloud/submodules/gamecloudheader/gamecloudheader';
import { initStatus } from './gamecloud/submodules/configuration/status';
import { initMapGroup } from './gamecloud/submodules/mapgroups/mapgroup';
import { initSupport } from './support/support';
import { initAtlasMap } from './gamecloud/submodules/atlas-map/atlas-map';
import { initRef } from './ref/ref';
import { initBackup } from './gamecloud/submodules/backup/backup';
import { initClusterNode } from './gamecloud/submodules/atlas-map/cluster-node';
import { initRegionfixer } from './gamecloud/submodules/regionfixer/regionfixer';
import { Redis } from './gamecloud/submodules/redis/redis';
import { initEditmap } from './gamecloud/submodules/atlas-map/atlas-editmap';
import { initServerList } from './gamecloud/list/serverlist';
import { initVoiceserver } from './gamecloud/submodules/voiceserver/voiceserver';
import { initRamMod } from './gamecloud/submodules/ramMod/ramMod';
import { initTeamspeak } from './teamspeak/teamspeak';
import { initAuth } from './auth/auth';
import { initLoading } from './loading/loading';
import { initFormAjax } from './gamecloud/submodules/formAjax/formAjax';
import { initReorder } from './gamecloud/submodules/reorder/reorder';
import { initProcon } from './procon/procon';
import { initAccount } from './account/account';
import Order, { initOrder } from './order/order';
import ClickEvent = JQuery.ClickEvent;
import { Company } from '@a/plugins/configuration/types/configuration';
import { TrackingEventTypes } from '@a/plugins/tracking/types/tracking';
import { publish } from '../shared/eventbus/eventbus';
import { Events } from '../shared/eventbus/events';
import Cookies from 'js-cookie';
import { initSearch } from './navigation/search';

if (process.env.NODE_ENV !== 'production') {
  console.log('Looks like we are in development mode!');
} else {
  console.log('Looks like we are in production mode!');
}

/* for the Google tag manager */
window.dataLayer = window.dataLayer || [];

export const trackGTM = (event: string, data: any) => {
  window.dataLayer.push({
    event,
    data,
  });
};

declare global {
  interface Window {
    $: JQuery;
    jQuery: JQuery;
    debug: boolean;
    basePath: string;
    nonLocalizedSelfUrl: string;
    regionPrefix: string;
    localePrefix: string;
    urlLanguage: string;
    interfaceApiUrl: string;
    socketURL: string;
    consoleUrl: string;
    ramUpdate: string;
    ramGetPrice: string;
    ajaxPath: string;
    startSize: any;
    gameserverId: number;
    currentSize: number;
    sliderRange: any;
    sliderValues: any;
    serverId: number;
    activatedModUrl: string;
    activateModUrl: string;
    homepageUrl: string;
    dashboardUrl: string;
    deactivateModUrl: string;
    activatedMods: IActivatedMod;
    changeModUrl: string;
    mapImagePath: string;
    installModUrl: string;
    uninstallModUrl: string;
    configWhenRunning: boolean | number;
    mapsData: IMapData;
    updateModsOrderUrl: string;
    activateAllModUrl: string;
    deactivateAllModUrl: string;
    gamesServerApiQuery: string;
    disableConfigSave: number;
    redirectSeconds: number;
    vueControllerBaseUrl: string;

    fetchServersForMenu: boolean;
    menuUrl: string;
    servicesUrl: string;

    /* Atlas */
    atlasGetMapCellsUrl: string;
    atlasGetNodesForClusterUrl: string;
    atlasGetNodesToCellUrl: string;
    atlasGetMapsUrl: string;
    atlasPostSubmitMapUrl: string;
    addExpansionServerUrl: string;
    atlasAlertMessage: string;
    atlasNodes: any;
    clusterBackupUrl: string;

    /* Backups */
    deleteBackupUrl: string;
    createBackupUrl: string;
    restoreBackupUrl: string;

    checkboxes: Checkbox[];

    findCheckboxByIndex(index: number): Checkbox;

    findCheckboxByBaseAttribute(name: string, value: string): Checkbox;

    tooltips: GPTooltip[];

    /* Server Lib Links */
    serverUnitSelectedId: number;
    gameserverUnit: Array<Array<string>>;

    getServers(): any;

    proconMessages: string[];

    /* check if the user is logged in */
    login_user: any;

    /* User Locale for Language */
    customerLanguageCode: string;
    customerCurrencyCode: string;

    /* General Payment information */
    paymentMethodQueryUri: string;
    getCustomerSavedPaymentMethodUri: string;
    disableSavedPaymentMethodUri: string;

    /* Recharge */
    rechargeMoneyUri: string;
    rechargeMoneyRedirectUri: string;

    /** Order & checkout */
    customerBalance: string;
    productIdent: any;
    order: Order;

    /* for pageTypes being written into the head */
    pageType: PageType;

    /* google tag manager */
    dataLayer?: object[];
    googleRecaptchaKey: string;

    /* svg icons related */
    cdnBaseUrl: string;

    company: Company;

    /* cookies vars */
    cookieDomain: string;
    cookiePath: string;
    cookieTimezoneName: string;

    wikiApiBaseUrl: string;
  }
}

window.debug = process.env.NODE_ENV !== 'production';

/* please don't move this under something else, servers and translations should be initiated first */
Server.initServer();

initGameserver();
initServerList();
initVoiceserver();
initGameserverStatus();
initSearch();
window.checkboxes = initCheckbox();
const list: Array<Modal> = initModal();
initConfiguration();
initGameserverHeader();
initMod();
initMap();
initLogs();
initPermissions();
initRestarts();
initConsole();
initGame();
initGameserverState();
initGamecloudheader();
initStatus();
initAdminbar();
initMapGroup();
initSupport();
initRef();
initAtlasMap();
initBackup();
initClusterNode();
initRegionfixer();
Redis.initRedis();
initEditmap();
initRegionNotification();
initRamMod();
initTeamspeak();
window.order = initOrder();
initFormAjax();
initAuth();
initReorder();
initLoading();
initProcon();

document.addEventListener('DOMContentLoaded', () => {
  initAccount();
});

window.addEventListener('openGamecloudEditor', (e: CustomEvent) => {
  publish(Events.OpenGamecloudEditModal, { orderId: Number(e.detail.data.orderId) });
});

window.addEventListener('openSlotsChangeEditor', (e: CustomEvent) => {
  publish(Events.OpenServerUnitEditModal, { orderId: Number(e.detail.data.orderId) });
});

$(document).on('click', '[data-open-recharge-modal]', () => {
  console.log('open recharge modal');
  publish(Events.OpenRechargeModal, {});
});

/**
 * this method which is bound to the window will help you find the right fancy checkbox by index,
 * it will return null if it does not find any checkbox
 * @param index
 */
window.findCheckboxByIndex = (index: number) => {
  const checkboxes = window.checkboxes.filter((checkbox) => checkbox.ui.index === index);

  return checkboxes.length ? checkboxes[0] : null;
};

window.findCheckboxByBaseAttribute = (name: string, value: string): Checkbox => {
  const checkboxes = window.checkboxes.filter((checkbox) => checkbox.ui.getBaseAttribute(name) === value);

  return checkboxes.length ? checkboxes[0] : null;
};

$(() => {
  $(document).on('click', '#add-payment-method-btn', (event: ClickEvent) => {
    trackGTM(TrackingEventTypes.PPP_BTN_PAYMENT_SAVE, {
      type: 'button',
      value: null,
    });
  });

  /*
     if (window.showCredit === 1 && window.login_user !== undefined) {
     window.initRechargeModal(window.creditPrice, window.creditCurrency);
     }
     */
});

/* Remember the clients local timezone */
const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
if (clientTimeZone !== undefined) {
  Cookies.set(
    window.cookieTimezoneName,
    clientTimeZone,
    {
      path: window.cookiePath,
      domain: window.cookieDomain,
      expires: 365,
      sameSite: 'Strict',
    },
  );
}
